// utils/session.js

const ACTIVITY_KEY = "last_activity_time";
const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 min

/* ================= ACTIVITY TRACKING ================= */
export const updateActivity = () => {
  localStorage.setItem(ACTIVITY_KEY, String(Date.now()));
};

/* ================= SET SESSION ================= */
export const setSession = (user, role = "user") => {
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("userEmail", user.email || "");
  localStorage.setItem("userId", String(user.id || ""));  // ✅ user_id save
  localStorage.setItem("role", role);
  localStorage.setItem("isLoggedIn", "true");

  updateActivity();
};

/* ================= CLEAR SESSION (SAFE) ================= */
export const clearSession = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("userEmail");
  localStorage.removeItem("userId");   // ✅ ye bhi clear karo
  localStorage.removeItem("role");
  localStorage.removeItem("isLoggedIn");
  localStorage.removeItem(ACTIVITY_KEY);
};

/* ================= GET SESSION ================= */
export const getSession = () => {
  return {
    user: JSON.parse(localStorage.getItem("user") || "null"),
    role: localStorage.getItem("role"),
    isLoggedIn: localStorage.getItem("isLoggedIn") === "true",
  };
};

/* ================= CHECK EXPIRY ================= */
export const isSessionExpired = () => {
  const last = localStorage.getItem(ACTIVITY_KEY);
  if (!last) return true;

  return Date.now() - Number(last) > SESSION_TIMEOUT;
};

/* ================= SAFE LOGIN CHECK ================= */
export const isLoggedIn = () => {
  const session = getSession();

  if (!session.isLoggedIn) return false;

  if (isSessionExpired()) {
    clearSession();
    return false;
  }

  return true;
};

/* ================= AUTO ACTIVITY HOOK ================= */
export const startActivityWatcher = () => {
  const events = ["click", "mousemove", "keydown", "scroll", "touchstart"];

  const handler = () => updateActivity();

  events.forEach((e) =>
    window.addEventListener(e, handler, { passive: true })
  );

  return () => {
    events.forEach((e) =>
      window.removeEventListener(e, handler)
    );
  };
};